import type {ComponentType, SVGProps} from "react";
import {BuildingOfficeIcon, PencilSquareIcon, ReceiptPercentIcon, TableCellsIcon} from "@heroicons/react/24/outline";

export type GoToItemId = 'vat' | 'trial-balance' | 'fixed-assets' | 'journal';

export interface GoToItem {
    id: GoToItemId;
    title: string;
    description: string;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const GO_TO_ITEMS: Record<GoToItemId, GoToItem> = {
    'vat': {id: 'vat', title: 'BTW-aangifte', description: 'Aangifte omzetbelasting per periode', Icon: ReceiptPercentIcon},
    'trial-balance': {id: 'trial-balance', title: 'Kolommenbalans', description: 'Proefbalans met drill-down per rekening', Icon: TableCellsIcon},
    'fixed-assets': {id: 'fixed-assets', title: 'Vaste activa', description: 'Activa en afschrijvingen', Icon: BuildingOfficeIcon},
    'journal': {id: 'journal', title: 'Memoriaal', description: 'Handmatige boekingen', Icon: PencilSquareIcon},
};

export const GO_TO_ITEM_ORDER = Object.keys(GO_TO_ITEMS) as GoToItemId[];

export function getGoToHref(clientId: string, itemId: GoToItemId): string {
    return `/business/${clientId}?tab=${itemId}`;
}

export function getVisibleGoToItemIds(getFlag: (flag: string) => boolean): GoToItemId[] {
    return GO_TO_ITEM_ORDER.filter((id) => {
        if (id === 'vat') return getFlag('PARTNER__CAN_SEE_VAT_DECLARATION');
        if (id === 'journal') return getFlag('PARTNER_CAN_MAKE_MANUAL_BOOKINGS');
        return true;
    });
}
